// extracted by mini-css-extract-plugin
export default {"title":"Person_title__qBjbF","inner":"Person_inner__TQJ68"};